// extracted by mini-css-extract-plugin
export default {"columns":"common-columns_pdfbr"};